import * as MerchantEvaluationRankTemplateApi from '@/api/merchant-evaluation-rank-template'
/**
 * 评审系统 - 奖项模板管理
 */

const state = {}

const mutations = {}

const actions = {
  async list ({ commit }, params) {
    return MerchantEvaluationRankTemplateApi.list(params)
  },
  async add ({ commit }, params) {
    return MerchantEvaluationRankTemplateApi.add(params)
  },
  async all ({ commit }, params) {
    return MerchantEvaluationRankTemplateApi.all(params)
  },
  async findById ({ commit }, id) {
    return MerchantEvaluationRankTemplateApi.findById(id)
  },
  async updateById ({ commit }, data) {
    return MerchantEvaluationRankTemplateApi.updateById(data.id, data)
  },
  async deleteById ({ commit }, id) {
    return MerchantEvaluationRankTemplateApi.deleteById(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-rank-template.js